module.exports = __webpack_public_path__ + "img/canvaslogo.73416094.svg";